export const Logo = () => (
  <>
    <svg
      width="21"
      height="34"
      viewBox="0 0 21 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="d-block m-auto mb-3 mt-2"
    >
      <path
        d="M8.20041 18.9724L6.86446 21.6075C6.86446 21.6075 13.0639 22.885 13.0639 22.901L14.0846 19.7709C13.8595 19.723 8.20041 18.9724 8.20041 18.9724Z"
        fill="#45D27E"
      />
      <path
        d="M18.9271 5.99512L10.8513 0.852796C9.20014 -0.20122 7.1887 -0.281069 5.47748 0.629217C3.75125 1.5395 2.59542 3.28023 2.38527 5.32438L0.0285862 28.4329C-0.136532 30.0618 0.418865 31.6109 1.55968 32.6969C2.52037 33.6071 3.75125 34.0543 4.99714 33.9744C5.23731 33.9585 5.47748 33.9265 5.71765 33.8627L11.4367 32.5372C13.3431 32.09 14.8592 30.6687 15.5197 28.7203L16.9457 24.4564C17.2609 23.5141 17.1708 22.4761 16.6755 21.5977C16.3002 20.927 15.7448 20.4319 15.0693 20.1605L12.6226 27.6344C12.3224 28.5127 11.6469 29.1675 10.7763 29.3591L5.05718 30.6846C4.5318 30.8124 3.99142 30.6527 3.60114 30.2694C3.19585 29.8861 3.00071 29.3432 3.06075 28.7682L5.43245 5.67572C5.52251 4.73349 6.03288 3.96693 6.82844 3.53575C7.62401 3.12053 8.50965 3.15247 9.27519 3.63157L17.351 8.78986C17.8013 9.07731 18.0264 9.63626 17.9064 10.1792L17.8013 13.6767L19.9778 15.0022L20.8785 10.9298C21.3138 8.99746 20.5332 7.01719 18.9271 5.99512Z"
        fill="#010024"
      />
    </svg>
  </>
);
